import { TimeBlockStatus } from "../../../entities-generated/common/time-block-status";
import { ITimeBlockStatusOption } from "../../../entities-generated/common/time-block-status-option";

export class TimeBlockEditorModel
{
  constructor()
  {
    this.statusOptions = [{
      id: TimeBlockStatus.Available,
      description: 'Available'
    }, {
      id: TimeBlockStatus.BlackedOut,
      description: 'Reserved'
    }];
  }

  public statusOptions: ITimeBlockStatusOption[];
}